import { AccountTO } from "../../backend-definitions.module";

export class FinancialClosing {
    id: number;
    accountId: any;
    dated: string;
    started: string;
    ended: string;
    justification: string;
    closed: boolean;
}

export class FinancialClosingTO{
     id: number;
     account: AccountTO;
     dated: string;
     started: string;
     ended: string;
     justification: String;
     closed: boolean;
}

export class FinancialClosingListTO {
    id:string;
    dated:string;
    started:string;
    ended:string;
    justification:string;
    accountCode:string;
    agencyName:string;
    closed: boolean;
}

